import { render, staticRenderFns } from "./DetailsSectionOrderAddressProducts.vue?vue&type=template&id=258c5d9a&"
import script from "./DetailsSectionOrderAddressProducts.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionOrderAddressProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports